import React, { VFC, ReactNode, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Auth } from '@prime/auth';
import * as AuthSelectors from '../redux/authSelectors';
import { API_REQUEST_STATE } from '../../enums/apiRequestState';
import * as Actions from '../redux/authActions';

export interface AuthProviderProps {
  OAuthClient: Auth;
  children: ReactNode;
}

const AuthProvider: VFC<AuthProviderProps> = ({ OAuthClient, children }) => {
  const dispatch = useDispatch();
  const [authenticated, setAuthenticated] = useState(() => OAuthClient.isAuthenticated());
  const apiMeRequestState = useSelector(AuthSelectors.apiMeRequestState);
  const me = useSelector(AuthSelectors.me);

  useEffect(() => {
    OAuthClient.init().then(() => {
      setAuthenticated(OAuthClient.isAuthenticated());
    });
  }, []);

  useEffect(() => {
    if (apiMeRequestState === API_REQUEST_STATE.IDLE && !me.id && authenticated) {
      dispatch(Actions.getMe());
    }
  }, [apiMeRequestState, authenticated]);

  return <>{authenticated && children}</>;
};

AuthProvider.propTypes = {
  children: PropTypes.node,
  // @ts-ignore
  OAuthClient: PropTypes.object,
};

export default AuthProvider;
